import { getNavigationAnalyticsItem } from '~/common/analytics/navigationTracking';

export function getSidebarAnalyticsItem(pathname: string) {
  return getNavigationAnalyticsItem(pathname);
}
